export default __webpack_public_path__ + "611782785f5eb479be8be16072025620.png";